import React, { useEffect } from "react"
import { connect } from "react-redux";
import * as layoutService from "../../view/layoutService";
import { withMainLayout } from "../../view/LayoutHOCs";
import { InfoBoxes } from "../../info-boxes/InfoBoxes";
import ValidateTableSection from "./ValidateTableSection";
import { clearValidateTable } from "../ruleService";

const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "Validate",
        redirectTo: "/validate",
    }
]

function ValidatePage() {

    useEffect(() => {
        layoutService.setPageTitle('Validate')
        layoutService.setBreadcrumbs(breadcrumbs)
        return () => clearValidateTable()
    }, [])

    return (
        <>
            <InfoBoxes />
            <ValidateTableSection />
        </>
    );
}


export default withMainLayout(connect()(ValidatePage));
